import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGithub } from '@fortawesome/free-brands-svg-icons';
import './product.css';
import { Link } from 'react-router-dom';
import { faCopy } from '@fortawesome/free-regular-svg-icons';
import { faLink } from '@fortawesome/free-solid-svg-icons';

const Product = ({ img, link, gitHub, originalLink }) => {
    return (
        <div className='productContainer'>
            <div className='p'>
                <div className='p-browser'>
                    <div className='p-circle'></div>
                    <div className='p-circle'></div>
                    <div className='p-circle'></div>
                </div>
                <a href={link} target='_blank' rel="noreferrer">
                    <img src={process.env.PUBLIC_URL +`${img}`} alt="" className='p-img' />
                </a>
            </div>
            <div className='icons'>
                <a href={gitHub}  target='_blank'  rel="noreferrer">
                    <FontAwesomeIcon className='icon' icon={faGithub} />
                </a>
                <a href={originalLink}  target='_blank'  rel="noreferrer">
                    <FontAwesomeIcon className='icon' icon={faCopy} />
                </a>
                <a href={link}  target='_blank'  rel="noreferrer">
                    <FontAwesomeIcon className='icon' icon={faLink} />
                </a>
            </div>
        </div>
    )
}

export default Product;